import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6 ModelField-colFirst" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1)
const _hoisted_5 = { class: "col-6 ModelField-colLast" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, [
  /*#__PURE__*/_createTextVNode("Объем (м"),
  /*#__PURE__*/_createElementVNode("sup", null, "3"),
  /*#__PURE__*/_createTextVNode(")")
], -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-4 ModelField-colFirst" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Длина доски (мм)", -1)
const _hoisted_10 = { class: "col-4 ModelField-col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Толщина доски (мм)", -1)
const _hoisted_12 = { class: "col-4 ModelField-colLast" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Ширина доски (мм)", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", null, "Свойства номенклатуры отгрузки (И)", -1)
const _hoisted_15 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog",
    onOnShown: _ctx.onShown,
    height: "90vh"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_TextControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Наименование...",
              "show-clear-button": true,
              value: model.name,
              "onUpdate:value": ($event: any) => ((model.name) = $event),
              hasEmptyValue: false,
              validationGroup: validationGroup
            }, null, 8, ["value", "onUpdate:value", "validationGroup"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_DecimalControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              value: model.volume,
              "onUpdate:value": ($event: any) => ((model.volume) = $event),
              hasEmptyValue: false,
              decimalPoints: 0,
              step: 1,
              min: 0
            }, null, 8, ["value", "onUpdate:value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              value: model.boardLength,
              "onUpdate:value": ($event: any) => ((model.boardLength) = $event),
              hasEmptyValue: true,
              min: 0
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              value: model.boardHeight,
              "onUpdate:value": ($event: any) => ((model.boardHeight) = $event),
              hasEmptyValue: true,
              min: 0
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              value: model.boardWidth,
              "onUpdate:value": ($event: any) => ((model.boardWidth) = $event),
              hasEmptyValue: true,
              min: 0
            }, null, 8, ["value", "onUpdate:value"])
          ])
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", { id: _ctx.nomenclaturePropertySubGridDomId }, null, 8, _hoisted_15)
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onOnShown"]))
}